import { Routes, Route } from 'react-router-dom'
import Landing from './Landing.jsx'
import Room from './Room.jsx'

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/room/:roomId" element={<Room />} />
    </Routes>
  )
}
